export default __webpack_public_path__ + "static/media/40_BottomRightSquares_Bottom.db67aa47.mp4";